import '@commons/initialize';
import Routing from '@pages/Routing';
import React from 'react';
import { RecoilRoot } from 'recoil';

const App = () => {
  return (
      <RecoilRoot>
        <Routing />
      </RecoilRoot>
  );
};

export default App;